import { useMemo } from 'react';
import { GET_CLASS_ANNOUNCEMENTS_USE_CASE, GET_CLASS_ANNOUNCEMENT_USE_CASE, CREATE_CLASS_ANNOUNCEMENT_USE_CASE, UPDATE_CLASS_ANNOUNCEMENT_USE_CASE, PIN_CLASS_ANNOUNCEMENT_USE_CASE, DELETE_CLASS_ANNOUNCEMENT_USE_CASE } from '@module/class';
export var useClassAnnouncementClient = function useClassAnnouncementClient(execute) {
  return useMemo(function () {
    return {
      list: function list(classId, nextToken, limit) {
        return execute(GET_CLASS_ANNOUNCEMENTS_USE_CASE, {
          classId: classId,
          nextToken: nextToken,
          limit: limit
        });
      },
      get: function get(classId, id) {
        return execute(GET_CLASS_ANNOUNCEMENT_USE_CASE, {
          classId: classId,
          id: id
        });
      },
      create: function create(classId, input) {
        return execute(CREATE_CLASS_ANNOUNCEMENT_USE_CASE, {
          classId: classId,
          input: input
        });
      },
      update: function update(classId, id, input) {
        return execute(UPDATE_CLASS_ANNOUNCEMENT_USE_CASE, {
          classId: classId,
          id: id,
          input: input
        });
      },
      pin: function pin(classId, id, pinned, version) {
        return execute(PIN_CLASS_ANNOUNCEMENT_USE_CASE, {
          classId: classId,
          id: id,
          pinned: pinned,
          version: version
        });
      },
      "delete": function _delete(classId, id, version) {
        return execute(DELETE_CLASS_ANNOUNCEMENT_USE_CASE, {
          classId: classId,
          id: id,
          version: version
        });
      }
    };
  }, [execute]);
};